import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { changeFormFieldValue, removeFieldError, updateFormProperties } from 'apps/auth/actions/formAction';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelFrame } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import { hasContacts } from 'apps/auth/components/form-multi/utils';
import { PHONE } from 'apps/auth/constants/fieldsName';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import PhoneContacts from './PhoneContacts';
import PhonePopup from './PhonePopup';

const PhoneBook = (props) => {
    const popupRef = useRef(null);

    const { friendTitle: title, enterTextDescription: enterText, selectRecipientTitle } = usePageMessages();

    const openPopup = (e) => {
        e.preventDefault();

        Promise.all([props.updateFormProperties(props.formName, null, false), props.changeFormFieldValue(props.formName, '', PHONE)]).then(() => {
            popupRef.current?.open(
                <PhonePopup setScreen={props.setScreen} formName={props.formName} action={props.action} isLibreFlow={props.isLibreFlow} popupRef={popupRef} />,
            );
        });
    };

    return (
        <>
            <HeaderPanel title={props.isLibreFlow ? selectRecipientTitle : title} />
            <Row indent="48px">
                <Panel isHoverable negativeMargin onClick={openPopup}>
                    <PanelFrame>
                        <DiskBadgeWrapper>
                            <DiskBadge iconName="dialpad" variant="secondary" />
                        </DiskBadgeWrapper>
                        <Text color="primary">{enterText}</Text>
                    </PanelFrame>
                </Panel>
            </Row>
            {hasContacts() && (
                <PhoneContacts
                    submitRef={props.submitRef}
                    formName={props.formName}
                    action={props.action}
                    toCountryCode={props.toCountryCode}
                    toCurrencyCode={props.toCurrencyCode}
                    url={props.url}
                />
            )}
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = ({ extra, form }, ownProps) => ({
    fields: form[ownProps.formName].fields,
    phoneField: form[ownProps.formName].fields.phone,
    pocketId: extra.pocket?.id,
    toCountryCode: extra.toCountry?.code,
    toCountryName: extra.toCountry?.name,
    toCurrencyCode: extra.toCurrency?.code.toLowerCase(),
    deliveryMethod: extra.deliveryMethod,
});

export default connect(mapStateToProps, { changeFormFieldValue, removeFieldError, updateFormProperties })(PhoneBook);
